<template>
  <div class="register-warpper">
    <div v-if="showTermDialog">
      <termList v-on:agreeList="agreeListHide" v-on:e_Callback="ListHide" type="phr_reg"></termList>
    </div>
    <div class="container-img">
      <div class="register-img">
        <h1 class="websiteTitle" v-text="websiteTitle"></h1>

        <!--        <img src="../../assets/images/logo.png" alt />-->
        <!--        <img src="../../assets/images/logo4.png" alt />-->
      </div>
      <div class="container">
        <infoForm ref="infoForm" title="注册" fromType="register" @on-submit="submitHandle" submit="提交" align="返回登录" @on-align="onAlign">
          <el-form-item slot="name">
            <el-input v-model="name" placeholder="请输入用户名">
              <el-button slot="prepend" icon="el-icon-user"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item slot="forget" prop="captcha">
            <el-input v-model="captcha" placeholder="短信验证" type="username">
              <el-button slot="append" type="primary" class="sendBtn" @click="sendPhoneCode" :disabled="sendCodeBtnDisable">{{ code_tip }}</el-button>
            </el-input>
          </el-form-item>
          <el-form-item slot="termHandle">
            <label class="agreeRadio">
              <el-checkbox v-model="isAgree" :style="{'--fill-color':'#FC701A'}"></el-checkbox>
              <span class="agree-span">已同意相关的协议</span>
              <span class="mainTextColor" @click="termHandle()">《服务和隐私协议》</span>
            </label>
          </el-form-item>
        </infoForm>
      </div>
    </div>
    <div class="record_num" v-text="icp_number"></div>
  </div>
</template>

<script>
import infoForm from "@/components/infoForm/index.vue";
import util from "@/utils";
import termList from "@/components/common/termList";
import { getCaptcha, publicsReg } from "@/api/index.js";
export default {
  name: "Register",
  components: {
    infoForm,
    termList,
  },
  props: {},
  data() {
    return {
      code_time: 60,
      code_tip: "发送验证码",
      sendCodeBtnDisable: false,
      showTermDialog: false,
      isAgree: false,
      captcha: "",
      name: "",
      icp_number: util.icp_number,
      websiteTitle: util.copyrightName + util.WebsiteTitle,
    };
  },
  created() { },
  mounted() { },
  activited() { },
  update() { },
  beforeRouteUpdate() { },
  methods: {
    onAlign(type) {
      this.go("/login");
    },

    go(url) {
      this.$router.push({
        path: url,
      });
    },
    /*
     * 提示信息
     * */
    elementTips: function (type, message) {
      const $t = "";
      this.$message({
        showClose: true,
        message: message,
        type: type,
      });
    },
    /*监听同意按钮*/
    agreeListHide: function () {
      this.isAgree = true;
      this.showTermDialog = false;
    },
    //设置关闭协议弹框后不选中
    ListHide() {
      this.isAgree = false;
      this.showTermDialog = false;
    },
    termHandle() {
      this.showTermDialog = true;
    },
    /*
     *  注册绑定模式:0, 登录验证:1, 修改密码模式:2, 修改手机号:3；
     * */
    async sendPhoneCode() {
      try {
        /**
         * 获取组件中表单中的手机号码
         */
        let mobile = this.$refs.infoForm.loginForm.username;
        if (mobile === "") {
          this.elementTips("error", "手机号码不能为空");
          return;
        }
        const params = {
          smsMode: "0",
          mobile: mobile,
        };
        let res = await getCaptcha(params);
        if (res.success) {
          this.countDown();
          this.elementTips("success", res.message);
          this.sendCodeBtnDisable = true;
        } else {
          this.sendCodeBtnDisable = false; //错误的情况下 解除禁止
          this.elementTips("warning", res.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    /*
     * 倒计时
     * */
    countDown() {
      const that = this;
      const timer = setInterval(() => {
        that.code_tip = this.code_time + "s";
        that.code_time--;
        if (that.code_time <= 0) {
          clearInterval(timer);
          that.sendCodeBtnDisable = false;
          that.code_tip = "获取验证码";
          that.code_time = 60;
        }
      }, 1000);
    },
    /**
     * 提交注册
     */
    async submitHandle(userInfo) {

      try {
        if (!this.name) {
          this.elementTips("error", "请输入用户名");
          return;
        }
        // ^[0-9]*$
        var reg = /^[\u4e00-\u9fa5]{2,4}$/;
        // console.log(reg.test(this.name));
        if (!reg.test(this.name)) {
          this.elementTips("error", "用户名只能为中文2~4位!");
          return;
        }
        if (!this.captcha) {
          this.elementTips("error", "请输入验证码");
          return;
        }

        if (!this.isAgree) {
          this.elementTips("error", "请同意使用条款");
          return;
        }
        var params = {
          username: this.name,
          mobile: userInfo.username,
          password: userInfo.password,
          captcha: this.captcha,
        };
        let res = await publicsReg(params);
        var that = this;
        if (res.success) {
          this.elementTips("success", res.message);
          setTimeout(() => {
            that.go("/login");
          }, 1500);
        } else if (res.code === 1000039) {
          //用户已经存在
          this.elementTips("success", res.message);
          setTimeout(() => {
            that.go("/login");
          }, 1000);
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.register-warpper {
  background-image: url("../../assets/images/login-bg2.jpg");
  width: 100%;
  height: 100%;
  // position: relative;
  display: flex;
  justify-content: center;
  align-content: center;
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: hidden;

  .container-img {
    position: relative;
    top: 15%;
    // left: 50%;
    // margin: -300px 0 0 -175px;
    width: 400px;
    overflow: hidden;
    border-radius: 15px;
    background-size: 100% 100%;
    .register-img {
      text-align: center;
      margin: 20px 0;
      img {
        height: 70px;
      }
    }

    .websiteTitle {
      width: 100%;
      text-align: center;
      line-height: 50px;
      font-size: 30px;
      // color: #fc701a;
      font-family: Noto Sans S Chinese;
      font-weight: bold;
    }
  }

  .container {
    background: #ffffff;
    overflow: hidden;
    border-radius: 15px;
    background-size: 100% 100%;
    box-shadow: 0 0 30px #ccc;
    margin: 10px 20px 30px 20px;
  }
  .mainTextColor {
    color: #fc701a;
  }
  .agree-span {
    margin-left: 10px;
  }
  .sendBtn {
    color: #fff;
    border-radius: 0;
  }
  .loginBtn {
    text-align: center;

    button {
      width: 100%;
      height: 36px;
      margin-bottom: 10px;
    }
  }
}

::v-deep .el-checkbox {
  .el-checkbox__label {
    color: var(--fill-color);
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: var(--fill-color);
    border-color: var(--fill-color);
  }

  .el-checkbox__input.is-focus .el-checkbox__inner,
  .el-checkbox__inner:hover {
    border-color: var(--fill-color);
  }
}
</style>
